<template>
  <w-tool-tip class="aiCreditsToolTip" :label="$t('generic.aiCreditsTooltip')" :interactive="true" :position="position">
    <slot>
      <w-icon class="aiCreditsIcon" icon="star-four-points-circle-outline" size="small" color="warning"/>
    </slot>
  </w-tool-tip>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import WIcon from '@/components/wrapper/w-icon.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';

@Component({
  components: {WToolTip, WIcon}
})
export default class AiCreditsToolTip extends Vue {
  @Prop({default: 'auto'})
  private position!: string;
}
</script>

<style scoped lang="scss">
.aiCreditsToolTip .aiCreditsIcon.icon.is-small {
  margin: 0;
  font-size: 16px;
  cursor: help;
}
</style>
